import { getClientEnv } from './clientEnv';

// Google Maps API Key - Obtener de manera segura para cliente y servidor
let GOOGLE_MAPS_API_KEY = '';

// Compatibilidad con entorno de servidor (Node.js)
if (typeof process !== 'undefined' && process.env) {
  // Entorno Node.js (servidor)
  GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY || '';
} else if (typeof window !== 'undefined') {
  // Entorno del navegador (cliente)
  const { googleMapsApiKey } = getClientEnv();
  GOOGLE_MAPS_API_KEY = googleMapsApiKey || '';
}

// Limpiar comillas si existen
GOOGLE_MAPS_API_KEY = GOOGLE_MAPS_API_KEY.replace(/['"]+/g, '');

// Solo lanzar error en producción
if (!GOOGLE_MAPS_API_KEY && (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production')) {
  console.warn('Google Maps API key is not set. Maps functionality may be limited.');
}

export { GOOGLE_MAPS_API_KEY };

// Default map center (Caracas, Venezuela)
export const DEFAULT_CENTER = {
  lat: 10.4806,
  lng: -66.9036
};

// Map Styles - Tema claro personalizado
export const MAP_STYLES = [
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ visibility: "simplified" }]
  },
  {
    featureType: "poi",
    stylers: [{ visibility: "simplified" }]
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [{ visibility: "simplified" }]
  },
  {
    featureType: "water",
    stylers: [{ color: "#e3f2fd" }]
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "simplified" }]
  },
  {
    featureType: "landscape",
    stylers: [{ color: "#f5f5f5" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }]
  },
  {
    featureType: "road.local",
    stylers: [{ color: "#ffffff" }]
  },
  {
    featureType: "road.arterial",
    stylers: [{ color: "#ffffff" }]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#696969" }]
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [{ visibility: "on" }, { color: "#737373" }]
  },
  {
    featureType: "poi",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{ color: "#d6d6d6" }]
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }]
  }
]; 